export const UPDATE_NOW_DATA_SUCCESS = 'UPDATE_NOW_DATA_SUCCESS'
